import React from "react"
import {connect} from "react-redux"
import {RecognitionAreaData} from "../../util/interfaceData"
import ErrorFieldStyles from "./errorField.less"

export class ErrorField extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
    }

    render() {
        const errorField = this.props.errorField.map((item: RecognitionAreaData, index: number) => {
            return [
                <tbody key={index + item.key}>
                    <tr>
                        <td valign="top" className={ErrorFieldStyles.tdStyle}>
                            {item.key}
                        </td>
                        <td valign="top" className={ErrorFieldStyles.tdText}>
                            {item.value}
                        </td>
                    </tr>
                </tbody>,
            ]
        })
        return [errorField]
    }
}
export default connect((state: any) => {
    return {
        errorField: state.errorField,
    }
})(ErrorField)
